/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Cocktail',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M13.053 4.78c.582 0 1.053.472 1.053 1.054s-.471 1.053-1.053 1.053S12 6.415 12 5.834s.472-1.054 1.054-1.054z" />
          <path
            fillRule="evenodd"
            d="M19.433 2.002c.923 0 1.354 1.145.659 1.753l-7.434 6.501-.011.008v9.437a1 1 0 0 0 1 1h1.482a.65.65 0 0 1 .648.648.65.65 0 0 1-.648.647H8.87a.65.65 0 0 1-.647-.647.65.65 0 0 1 .647-.648h1.482a1 1 0 0 0 1-1v-9.437L3.908 3.755l-.117-.12c-.522-.627-.09-1.633.775-1.633h14.867zM12 9.238l6.901-6.035H5.099L12 9.238z"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
